module.exports = "<nv-icon-button *ngIf=\"showTrash\" (clickButton)=\"openDeleteConfirmModal()\" name=\"trash\"></nv-icon-button>\n"